import React from "react";
import { useLang } from "../lib/LangContext";

export default function LanguageSwitch() {
  const { lang, setLang, t } = useLang();
  const other = lang === "fr" ? "en" : "fr";
  return (
    <button
      type="button"
      onClick={() => setLang(other)}
      aria-label={t("lang.aria")}
      title={t("lang.aria")}
      data-testid="language-switch"
      data-lang={lang}
      className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full border border-slate-300 hover:border-slate-900 text-slate-700 hover:text-slate-900 transition-colors"
    >
      <span aria-hidden className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#DE0F72" }} />
      {t("lang.switch_to")}
    </button>
  );
}
